import React, { useEffect, useState } from "react";
import CountUp from "react-countup";
import {
  calculerRedevanceForfaitaire,
  calculerRedevanceForfaitaire_2,
  calculerRedevanceProportionnelle,
} from "../utils/calculRedevances";

import { CiWarning } from "react-icons/ci";

const Form = ({
  fields,
  send,
  showForm,
  setShowForm,
  selectedData,
  selected,
  selectType,
  fieldsTarif,
}) => {
  const [dataToSend, setDataToSend] = useState({});
  const [localFields, setLocalFields] = useState(fields);
  const [originalFields, setOriginalFields] = useState();
  const [errors, setErrors] = useState({});
  const [prix, setPrix] = useState();
  const pathname = window.location.pathname;

  console.log("pathname", pathname);

  useEffect(() => {
    if (selectedData) {
      // On transforme les champs objets en leur id
      const transformed = Object.fromEntries(
        Object.entries(selectedData).map(([key, value]) => {
          if (value && typeof value === "object" && value.id !== undefined) {
            return [key, value.id];
          }
          return [key, value];
        })
      );
      setDataToSend(transformed);
      const filteredFields = fields?.filter(field => field.attributes?.field_id !== "password");      
            console.log('les champs', filteredFields);
    
      setLocalFields(filteredFields); // <-- Ajoute cette ligne si tu utilises un état local pour les fields
    } else {
      setDataToSend({});
    }
  }, [selectedData]);

  const onChange = (e) => {
    const { id, value } = e.target;
    const updatedData = { ...dataToSend, [id]: value };

    setDataToSend(updatedData);

    console.log("updatedData", dataToSend);
    if (id === "type") selectType(value);

    if (id === "category2") {
      updateFieldsBasedOnTarif(updatedData); // <== utilise la nouvelle valeur
    }

    

    setErrors((prev) => ({ ...prev, [id]: "" }));
  };

  

  const validateForm = () => {
    const newErrors = {};
    fields.forEach((item) => {
      if (item.attributes.required && 
          item.attributes.field_id !== "password" && 
          !dataToSend[item.attributes.field_id]) {
        newErrors[
          item.attributes.field_id
        ] = `Ce champ ${item.attributes.field_id} est requis`;
      }
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = () => {

    console.log("data to send before validation", dataToSend);
    if (validateForm()) {
      if (pathname.includes("usagers") && !selectedData) {
        dataToSend.type = selected && JSON.parse(selected)?.value;
        dataToSend.category = dataToSend.category2;
      }
      if(prix) dataToSend.montant = +prix;
      console.log("data to send", dataToSend);
      send(dataToSend);

      setDataToSend({}); // Réinitialiser les données après l'envoi
      setPrix(null); // Réinitialiser le prix après l'envoi
    }
  };
  
  function isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
  }

  const calculateRedevance = () => {

    console.log("Calculating redevance with dataToSend:", dataToSend);
    if (
      dataToSend.typeEtablissement &&
      dataToSend.capaciteAccueil &&
      dataToSend.region
    ) {
      const data = {
        type: dataToSend.typeEtablissement,
        zone: dataToSend.region,
        capacite: dataToSend.capaciteAccueil,
        etoiles: +dataToSend.etoiles,
      };
      setPrix(calculerRedevanceForfaitaire(data));
    } else if (
      dataToSend.category2 &&
      (dataToSend.typeVehicule ||
        dataToSend.typeCommerce ||
        dataToSend.typeInfraSportive ||
        dataToSend.diffusion ||
        dataToSend.typeGares ||
        dataToSend.typeTelephone ||
        dataToSend.typeRadioTv ||
        dataToSend.typeInfraSportive ||
        dataToSend.typeBanque)
    ) {
      const data = {
        type: dataToSend.category2,
        sousType:
          dataToSend.typeVehicule ||
          dataToSend.typeCommerce ||
          dataToSend.typeBanque ||
          dataToSend.typeInfraSportive ||
          dataToSend.typeGares ||
          dataToSend.typeTelephone ||
          dataToSend.typeRadioTv ||
          dataToSend.typeInfraSportive ||
          dataToSend.region,
        superficie: Number(dataToSend.superficie),
        capacite: dataToSend.capaciteAccueil,
        nombrePlaces: dataToSend.nombrePlaces,
        diffusion: dataToSend.diffusion,
        zone: dataToSend.zone,
        radioModel: dataToSend.radioModel,
      };

      console.log('data to send for redevance', data);
      setPrix(calculerRedevanceForfaitaire_2(data));
    } else if (
      dataToSend.typeOeuvre &&
      dataToSend.montantBase &&
      dataToSend.contexte
    ) {
      const data = {
        categorie: dataToSend.typeOeuvre,
        montantBase: dataToSend.montantBase,
        butNonLucratif: dataToSend.contexte === "true",
      };
      setPrix(calculerRedevanceProportionnelle(data));
    }
  };

  useEffect(() => {
    calculateRedevance();
  }, [dataToSend]);

  useEffect(() => {
    setOriginalFields(fields);
    setLocalFields(fields);
  }, [fields]);

  const updateFieldsBasedOnTarif = () => {
    const currentCategory = dataToSend?.category2;

    console.log('Data to send', dataToSend);

    const baseFields = originalFields?.filter((field) => {
      const category = field.attributes.category?.toLowerCase();
      return (
        category === "identity" ||
        category === "common" ||
        category === "general"
      );
    });

    const fieldKey = `type${
      currentCategory?.charAt(0).toUpperCase() + currentCategory?.slice(1)
    }`;

    console.log("fieldKey", fieldKey);

    const foundField = fieldsTarif?.attributes?.fields?.data.find(
      (item) => item.attributes.field_id === fieldKey
    );

    const superFicieExist = localFields?.find(
      (item) => item.attributes.field_id === "superficie"
    );

    const infraSportiveExist = localFields?.find(
      (item) => item.attributes.field_id === "nombrePlaces"  
    );

    const etoilesExist = localFields?.find(
      (item) => item.attributes.field_id === "etoiles"
    );

    const vehiculeExist = localFields?.find(
      (item) => item.attributes.field_id === "nombrePlaces"
    );

    const typeGaresExist = localFields?.find(
      (item) => item.attributes.field_id === "typeGares" 
    );

    const nombrePlacesExist = localFields?.find(
      (item) => item.attributes.field_id === "nombrePlaces"
    );
    
    const typeTelephonieExist = localFields?.find(
      (item) => item.attributes.field_id === "typeTelephone"  
    );

    if (
      dataToSend.category2 === "commerce" &&
      dataToSend.typeCommerce &&
      (!superFicieExist ||
      !nombrePlacesExist)
    ) {
      
      let  additionalField

      if( dataToSend.typeCommerce === "E" ) {
         additionalField = {
          id: "nombrePlaces",
          attributes: {
            field_id: "nombrePlaces",
            name: "Nombre de places",
            type: "number",
            placeholder: "Nombre de places",
            category: "identity",

            required: true,
          },  
        };
      }else{
         additionalField = {
          id: "superficie",
          attributes: {
            field_id: "superficie",
            name: "superficie",
            type: "number",
            placeholder: "Superficie",
            category: "identity",
  
            required: true,
          },
        };
  
  
       
  


    }
    setLocalFields([...localFields, additionalField]);
    }

    if (dataToSend.typeEtablissement === "hotel" && !etoilesExist) {
      const additionalField = {
        id: "etoiles",
        attributes: {
          field_id: "etoiles",
          name: "Etoiles",
          type: "number",
          placeholder: "Etoiles",
          category: "identity",

          required: true,
        },
      };

      setLocalFields([...localFields, additionalField]);
      return;
    }
    if (dataToSend.category2 === "infrastructures_sportives"  && !infraSportiveExist) {
      console.log('la catégorie infra sportive', dataToSend);
      const additionalField = {
        id: "typeInfraSportive",
        attributes: {
          field_id: "typeInfraSportive",
          name: "Type d'infrastructure sportive",
          type: "select",
          category: "identity",
          options: [
           { label: "Stade", value: "stade" },
            { label: "Basket", value: "basket" },
            { label: "Complexe", value: "complexe" },
            { label: "Piscine", value: "piscine" },
            { label: "Aerobics", value: "aerobics" },
            { label: "pmu", value: "pmu" },
          ],
          required: true,
        },
      };
      const additionalField2 = {
        id: "nombrePlaces",
        attributes: {
          field_id: "nombrePlaces",
          name: "Nombre de places",
          type: "select",
          placeholder: "Etoiles",
          category: "identity",
          options: [
            { label: "de 5 000 à 10 000 places", value: "moins_10000" },
            { label: "de 10 001 à 20 000 places", value: "entre_15000_20000" },
            { label: "Plus de 20000", value: "plus_20000" },
          ],
          required: true,
        },
      };

      setLocalFields([...localFields, additionalField, additionalField2]);
      return;
    }

    if (
      dataToSend.category2 === "vehicule" &&
      dataToSend.typeVehicule &&
      !vehiculeExist
    ) {
      console.log('la catégorie vehicules', dataToSend.category2);
      const additionalField = {
        id: "nombrePlaces",
        attributes: {
          field_id: "nombrePlaces",
          name: "Nombre de places",
          type: "number",
          placeholder: "Nombre de places",
          category: "identity",

          required: true,
        },
      };

      const additionalField2 = {
        id: "diffusion",
        attributes: {
          field_id: "diffusion",
          name: "diffusion",
          type: "select",
          placeholder: "Diffusion audio",
          category: "identity",
          options: [
            { label: "Audio", value: "audio" },
            { label: "Visuelle", value: "visuelle" },
          ],
          required: true,
        },
      };

      setLocalFields([...localFields, additionalField, additionalField2]);
      return;
    }


    
    if (
      dataToSend.category2 === "gares" &&
      !typeGaresExist
    ) {
      console.log('la catégorie de gares', dataToSend.category2);
      const additionalField = {
        id: "typeGares",
        attributes: {
          field_id: "typeGares",
          name: "Type de gare",
          type: "select",
          placeholder: "Nombre de places",
          category: "identity",
          options: [
            { label: "Bateau", value: "bateau" },
            { label: "Quai", value: "quai" },
            { label: "Aeoroport", value: "aeoropotrt" },
          ],
          required: true,
        },
      };



      setLocalFields([...localFields, additionalField]);
      return;
    }


    if (
      dataToSend.category2 === "telephonie" &&
      
      !typeTelephonieExist
    ) {
      console.log('la catégorie de telephonie', dataToSend.category2);
      const additionalField = {
        id: "typeTelephone",
        attributes: {
          field_id: "typeTelephone",
          name: "Type de telephone",
          type: "select",
          placeholder: "Type de telephone",
          category: "identity",
          options: [
            { label: "Cybercafé", value: "cybercafe" },
            { label: "Site spécialisé", value: "site_specialise" },
            // { label: "Aeoroport", value: "aeoropotrt" },   
          ],
          required: true,
        },
      };



      setLocalFields([...localFields, additionalField]);
      return;
    }

    const typeRadioTvExist = localFields?.find(
      (item) => item.attributes.field_id === "typeRadioTv"  
    );
    // Si la catégorie est "radio_television" et que le champ "typeTelephone" n'existe pas

    if (
      dataToSend.category2 === "radio_television" &&
      
      !typeRadioTvExist
    ) {
      console.log('la catégorie de telephonie', dataToSend.category2);
      const additionalField = {
        id: "typeRadioTv",
        attributes: {
          field_id: "typeRadioTv",
          name: "Type de radio ou télévision",
          type: "select",
          placeholder: "Type de radio ou télévision",
          category: "identity",
          options: [
            { label: "Télévision internationnale", value: "tv_internationale" },
            { label: "Télévision Locale", value: "tv_locale" },
            { label: "Radio diffusion", value: "radio_nationale" },
            { label: "Fournisseurs d'images", value: "fournisseur_image" },
            // { label: "Aeoroport", value: "aeoropotrt" },   
          ],
          required: true,
        },
      };

      const additionalField2 = {
        id: "zone",
        attributes: {
          field_id: "zone",
          name: "Zone",
          type: "select",
          placeholder: "Zone géographique",
          category: "identity",
          options: [
            { label: "Bamako", value: "Bamako" },
            { label: "Urbain", value: "Urbain" },
            { label: "Rural", value: "Rural" },
            { label: "International", value: "International" },
          ],
          required: true,
        },
      };

      const additionalField3 = {
        id: "radioModel",
        attributes: {
          field_id: "radioModel",
          name: "Modèle de radio",
          type: "select",
          placeholder: "Modèle de radio",
          category: "identity",
          options: [
            { label: "Radio commerciale", value: "commerciale" },
            { label: "Associative", value: "associative" },
          ],
          required: true,
        },
      };

      setLocalFields([...localFields, additionalField, additionalField2, additionalField3]);
      return;
    }

    
    const fieldExist = localFields?.find(
      (item) => item.attributes.field_id === foundField?.attributes?.field_id
    );
    if (foundField && !fieldExist) {

      console.log('foundField', foundField);
      console.log('fieldsTarif', fieldsTarif);
      console.log('fields exist', fieldExist);
      console.log('currentCategory', currentCategory);
      // Si le champ existe dans fieldsTarif, on l'ajoute aux champs locaux
      const options = foundField.attributes.options;
      const additionalField = {
        id: "options",
        attributes: {
          field_id: foundField.attributes.field_id,
          name: foundField.attributes.name,
          type: "select",
          placeholder: "Options",
          category: "identity",
          options:
            currentCategory === "commerce" ||
            currentCategory === "banque" ||
            currentCategory === "infraSportive" ||
            currentCategory === "vehicule" 
              ? options
              : options?.options?.map((opt) => ({
                  label: opt.superficie_ou_places || opt.capacite,
                  value: opt.montant_par_mois || opt.capacite,
                })),
          required: null,
        },
      };

      setLocalFields([...baseFields, additionalField]);
    }

    if (dataToSend.category2 === "") {
      setLocalFields(baseFields);
    }
  };

  useEffect(() => {
    updateFieldsBasedOnTarif();
  }, [dataToSend, fieldsTarif]);

  const renderField = (item) => {
    const { field_id, name, type, placeholder, options } = item.attributes;
    const value = dataToSend[field_id] || "";

    console.log("value", value);

    if (type === "textarea") {
      return (
        <textarea
          className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
          id={field_id}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
        />
      );
    } else if (type === "select") {
      return (
        <select
          className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
          id={field_id} 
          value={value?.data?.id ? value?.data?.id : value? value : ""}
          onChange={onChange}>
          <option value="">Sélectionnez une option</option>
          {options?.map((option, index) => (
            <option key={index} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      );
    } else {
      return (
        <input
          className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
          id={field_id}
          type={type}
          placeholder={placeholder}
          value={type !== "file" ? value : undefined}
          onChange={onChange}
        />
      );
    }
  };

  return (
    <div>
      <div className="flex justify-between items-center p-4 mb-4 border-b border-gray-400 rounded-t dark:border-gray-600">
        {console.log("selected", selected)}
        {pathname.includes("usagers") &&
          ((!selected && !selectedData) ||
            selected == "Choisissez un type de redevance") && (
            <div className="w-full flex space-x-4 justify-center items-center px-3 mb-6 md:mb-0">
              <p className="text-lg text-danger font-bold">
                Veuillez choisir un type de redevance avant de continuer
              </p>
              <CiWarning size={40} className="text-danger" />
            </div>
          )}
        {prix && (
          <div className="w-full flex flex-col justify-center items-center px-3 mb-6 md:mb-0">
            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
              Montant de la redevance
            </label>
            <p
              className="text-yellow-500 text-3xl font-extrabold shadow-lg bg-white rounded-lg px-4 py-2"
              style={{
                boxShadow:
                  "0 8px 15px rgba(0, 0, 0, 0.2), 0 4px 6px rgba(0, 0, 0, 0.1)",
              }}>
              <CountUp
                start={0}
                end={prix}
                duration={2.5} // Durée de l'animation en secondes
                separator=" " // Séparateur pour les milliers
                decimals={0} // Nombre de décimales
                suffix=" Fcfa" // Texte ajouté après le nombre
              />
            </p>
          </div>
        )}
      </div>
      <form className="w-full">
        <div className="flex flex-wrap -mx-3 mb-6">
          {localFields?.map((item) => (
            <div key={item.id} className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
              <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                {item?.attributes?.name}
              </label>
              {renderField(item)}
              {errors[item?.attributes?.field_id] && (
                <p className="text-red-500 text-xs italic">
                  {errors[item?.attributes?.field_id]}
                </p>
              )}
            </div>
          ))}
        </div>
        <div className="flex items-center p-4 md:p-5 border-t border-gray-200 rounded-b dark:border-gray-600">
          <button
            disabled={
              pathname.includes("usagers") && !selected && !selectedData
            }
            type="button"
            className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
            onClick={handleSubmit}>
            {selectedData ? "Mettre à jour" : "Envoyer"}
          </button>
          <button
            type="button"
            className="ms-3 text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
            onClick={() => setShowForm(false)}>
            Annuler
          </button>
        </div>
      </form>
    </div>
  );
};

export default Form;
